<!-- Header Section -->
<app-filtros-reporte>
  <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      <!-- Rango de fechas y tipo movimiento -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-calendar-range"></i>
          Rango de fechas
        </label>
        <div
          class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300"
        >
          <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
            <i class="bi bi-calendar text-sm"></i>
          </span>
          <app-datepicker
            ngSkipHydration
            class="flex-1"
            [borderless]="true"
            [formField]="$any(fromularioFiltro.rangoFecha)"
            selectionMode="range"
            [maxDate]="maxDate"
            placeholder="Seleccione un rango"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showButtonBar]="true"
            [invalid]="
              fromularioFiltro.rangoFecha().touched() && fromularioFiltro.rangoFecha().invalid()
            "
          />
        </div>
        @if (fromularioFiltro.rangoFecha().touched() && fromularioFiltro.rangoFecha().invalid()) {
          <small class="text-sm text-red-600">{{
            fromularioFiltro.rangoFecha().errors() | formErrorMessage
          }}</small>
        }
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-2 sm:gap-3">
      <button
        type="submit"
        class="vc-btn-primary px-3 sm:px-4 py-2 sm:py-2.5 flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-search"></i>
        <span class="hidden sm:inline">Buscar</span>
      </button>
      <button
        type="button"
        (click)="limpiarFiltros()"
        class="vc-btn-secondary px-3 sm:px-4 py-2 sm:py-2.5 flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-arrow-clockwise"></i>
        <span class="hidden sm:inline">Limpiar</span>
      </button>
    </div>
  </form>
</app-filtros-reporte>

@if (hasDashboardData()) {
  <!-- KPI Cards Row -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
    <!-- Total Ventas -->
    <app-card-estadistico
      [titulo]="'Ventas Totales'"
      [valor]="(resumen_operacionales()!.ventas_totales | currency: 'PEN' : 'S/. ') || '0'"
      [color]="'blue'"
      [icono]="'bi bi-currency-dollar text-xl text-blue-600'"
      [tooltip]="
        'Total de ventas registradas en el periodo filtrado. Corresponde a la suma de venta.total y no incluye egresos ni vuelto.'
      "
    />

    <!-- Total Boletas -->
    <app-card-estadistico
      [titulo]="'Boletas Emitidas'"
      [valor]="boletas_emitidas().toString()"
      [color]="'green'"
      [icono]="'bi bi-receipt text-xl text-emerald-600'"
    />

    <!-- Total Facturas -->
    <app-card-estadistico
      [titulo]="'Facturas Emitidas'"
      [valor]="facturas_emitidas().toString()"
      [color]="'purple'"
      [icono]="'bi bi-file-text text-xl text-purple-600'"
    />

    <!-- Notas de Venta -->
    <app-card-estadistico
      [titulo]="'Notas de Venta'"
      [valor]="notas_venta_emitidas().toString()"
      [color]="'yellow'"
      [icono]="'bi bi-file-earmark text-xl text-yellow-600'"
    />
  </div>

  <!-- Charts and Analytics Row -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
    <!-- Ventas por Tipo de Documento -->
    <div class="lg:col-span-2">
      <app-card-chart-1
        [type]="'bar'"
        [titulo]="'Montos Totales por Tipo de Emisión'"
        [data]="resumen_documentos_emitidos_monto_chart()"
        [tipoData]="'dinero'"
        [inputBasicOptions]="{
          cutout: '60%',
          plugins: {
            legend: {
              labels: {
                color: '#374151',
              },
            },
          },
        }"
      />
    </div>
    <!-- Estado de Ventas Pie Chart -->
    <div class="lg:col-span-1">
      <app-card-chart-1
        [type]="'doughnut'"
        [titulo]="'Cantidad de Documentos Emitidos'"
        [data]="resumen_documentos_emitidos_cantidad_chart()"
        [tipoData]="'cantidad'"
        [showLegend]="true"
        [inputBasicOptions]="{
          cutout: '60%',
          plugins: {
            legend: {
              labels: {
                usePointStyle: true,
                color: '#374151',
              },
            },
          },
        }"
      />
    </div>
  </div>

  <!-- Productos Más Vendidos y Resumen -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    <div class="vc-surface p-6">
      <div class="mb-6">
        <h2 class="text-xl font-bold text-slate-900 flex items-center gap-2">
          <i class="bi bi-star text-yellow-500"></i>
          Productos Más Vendidos
        </h2>
        <p class="mt-1 text-sm text-slate-500">Top de productos que mejor rotan en el periodo</p>
      </div>
      <div class="space-y-3 max-h-96 overflow-y-auto pr-2">
        @for (item of productos_mas_vendidos_ul(); let i = $index; track i) {
          <div class="flex flex-col gap-3">
            <app-li-style-1 [maximo_valor]="maximo_valor_productos_mas_vendidos()" [item]="item" />
          </div>
        }
      </div>
      <div class="mt-4 flex justify-center">
        @if (productos_mas_vendidos_has_more()) {
          <button
            type="button"
            [disabled]="cargando_mas_productos_mas_vendidos()"
            (click)="cargarMasProductosMasVendidos()"
            class="vc-btn-secondary px-4 py-2 text-sm"
          >
            @if (cargando_mas_productos_mas_vendidos()) {
              Cargando...
            } @else {
              Cargar más
            }
          </button>
        } @else if (productos_mas_vendidos() && productos_mas_vendidos()!.length > 0) {
          <span class="text-xs text-slate-500">No hay más productos para mostrar</span>
        }
      </div>
    </div>

    <!-- Resumen de Operaciones -->
    <div class="vc-surface p-6">
      <div class="mb-6">
        <h2 class="text-xl font-bold text-slate-900 flex items-center gap-2">
          <i class="bi bi-table text-blue-600"></i>
          Resumen de Operaciones
        </h2>
        <p class="mt-1 text-sm text-slate-500">
          Visión consolidada de ventas y documentos emitidos
        </p>
      </div>

      <!-- Resumen Mensual -->
      <div class="mb-6 pb-6 border-b border-slate-200">
        <div class="space-y-3">
          <div class="flex justify-between items-center">
            <span class="text-slate-700 text-sm"
              >Ventas realizadas
              <i
                class="bi bi-info-circle text-blue-500 text-xs cursor-help"
                appTooltip="Corresponde a la suma de venta.total de todas las ventas realizadas en el periodo filtrado. No incluye egresos ni vuelto."
                tooltipPosition="top"
              ></i>
            </span>
            <span class="font-bold text-slate-900">{{
              resumen_operacionales()!.ventas_totales | currency: 'PEN' : 'S/. '
            }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-slate-700 text-sm">Transacciones</span>
            <span class="font-bold text-slate-900">{{
              resumen_operacionales()!.transacciones
            }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-slate-700 text-sm">Clientes atendidos</span>
            <span class="font-bold text-slate-900">{{
              resumen_operacionales()!.clientes_atendidos
            }}</span>
          </div>
        </div>
      </div>

      <!-- Tipos de Documento -->
      <div class="mb-6 pb-6 border-b border-slate-200">
        <h3 class="text-sm font-bold text-slate-700 mb-4">Documentos Emitidos</h3>
        <div class="space-y-3">
          @for (item of resumen_documentos_emitidos(); let i = $index; track i) {
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <div
                  class="w-2 h-2 rounded-full"
                  [ngClass]="{
                    'bg-blue-500': item.tipo === ETipoDocumentoSUNAT.BOLETA,
                    'bg-green-500': item.tipo === ETipoDocumentoSUNAT.FACTURA,
                    'bg-yellow-500': item.tipo === ETipoDocumentoSUNAT.NOTA_VENTA,
                    'bg-red-500': item.tipo === ETipoDocumentoSUNAT.NOTA_CREDITO,
                  }"
                ></div>
                <span class="text-slate-700 text-sm">{{ item.tipo.split('_').join(' ') }}</span>
              </div>
              <span class="font-bold text-slate-900">{{ item.cantidad }}</span>
            </div>
          }
        </div>
      </div>

      <!-- Métodos de Pago -->
      <div>
        <h3 class="text-sm font-bold text-slate-700 mb-4">
          Métodos de Pago
          <i
            class="bi bi-info-circle text-slate-400 text-xs cursor-help"
            appTooltip="Desglose del dinero recibido según el tipo de transacción usado por el cliente, como efectivo, tarjeta, transferencia o crédito. Sirve para comparar cómo se cobraron las ventas, no para sumar la venta total."
            tooltipPosition="top"
          ></i>
        </h3>
        <div class="space-y-3 max-h-48 overflow-y-auto pr-2">
          @for (item of resumen_operacionales()!.pagos_por_metodo; let i = $index; track i) {
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <i
                  [ngClass]="{
                    'bi bi-cash text-green-600': item.tipoTransaccion === ETipoTransaccion.EFECTIVO,
                    'bi bi-credit-card text-blue-600':
                      item.tipoTransaccion === ETipoTransaccion.DIGITAL,
                    'bi bi-bank text-purple-600':
                      item.tipoTransaccion === ETipoTransaccion.TRANSFERENCIA,
                    'bi bi-wallet2 text-yellow-600':
                      item.tipoTransaccion === ETipoTransaccion.TARJETA,
                    'bi bi-card-checklist text-emerald-600':
                      item.tipoTransaccion === ETipoTransaccion.CHEQUE,
                    'bi bi-wallet-fill text-red-600':
                      item.tipoTransaccion === ETipoTransaccion.OTRO,
                    'bi bi-credit-card-2-back text-slate-600':
                      item.tipoTransaccion === ETipoTransaccion.CREDITO,
                  }"
                ></i>
                <span class="text-slate-700 text-sm">{{ item.metodo }}</span>
              </div>
              <span class="font-bold text-slate-900">{{
                item.monto | currency: 'PEN' : 'S/. '
              }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Cierres de caja -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    <!-- Línea Temporal de Ventas -->
    <app-card-chart-1
      [type]="'line'"
      [titulo]="
        'Línea Temporal de Ventas ' + (fromularioFiltro.rangoFecha().controlValue() | dateRangeText)
      "
      [data]="ventas_line_chart()"
      [inputBasicOptions]="{}"
      [tipoData]="'dinero'"
      [showLegend]="false"
    />

    <!-- Análisis de Clientes -->
    <div class="vc-surface p-6">
      <div class="mb-6">
        <h2 class="text-xl font-bold text-slate-900 flex items-center gap-2">
          <i class="bi bi-people text-emerald-600"></i>
          Análisis de Clientes
        </h2>
        <p class="mt-1 text-sm text-slate-500">Comportamiento y recurrencia de clientes</p>
      </div>
      <div class="space-y-4">
        <div class="p-4 bg-slate-50 rounded-lg">
          <div class="flex justify-between items-start mb-2">
            <span class="font-semibold text-slate-900">Clientes Nuevos</span>
            @if (resumen_clientes()!.nuevos.porcentaje > 0) {
              <span class="text-sm bg-green-100 text-green-700 px-2 py-1 rounded">
                +{{ resumen_clientes()!.nuevos.porcentaje }}%
              </span>
            } @else if (resumen_clientes()!.nuevos.porcentaje < 0) {
              <span class="text-sm bg-red-100 text-red-700 px-2 py-1 rounded">
                {{ resumen_clientes()!.nuevos.porcentaje }}%
              </span>
            } @else {
              <span class="text-sm bg-gray-100 text-gray-700 px-2 py-1 rounded"> Sin cambio </span>
            }
          </div>
          <p class="text-2xl font-bold text-slate-900">{{ resumen_clientes()!.nuevos.cantidad }}</p>
        </div>
        <div class="p-4 bg-slate-50 rounded-lg">
          <div class="flex justify-between items-start mb-2">
            <span class="font-semibold text-slate-900">Clientes Recurrentes</span>
            @if (resumen_clientes()!.recurrentes.porcentaje > 0) {
              <span class="text-sm bg-green-100 text-green-700 px-2 py-1 rounded">
                +{{ resumen_clientes()!.recurrentes.porcentaje }}%
              </span>
            } @else if (resumen_clientes()!.recurrentes.porcentaje < 0) {
              <span class="text-sm bg-red-100 text-red-700 px-2 py-1 rounded">
                {{ resumen_clientes()!.recurrentes.porcentaje }}%
              </span>
            } @else {
              <span class="text-sm bg-gray-100 text-gray-700 px-2 py-1 rounded"> Sin cambio </span>
            }
          </div>
          <p class="text-2xl font-bold text-slate-900">
            {{ resumen_clientes()!.recurrentes.cantidad }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Ingresos por Categoría -->
  @if (resumen_ingresos_por_categoria() && resumen_ingresos_por_categoria()!.length > 0) {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <app-card-chart-1
        [type]="'bar'"
        [titulo]="'Ingresos Totales por Categoría'"
        [data]="ingresos_por_categoria_chart()"
        [tipoData]="'dinero'"
        [showLegend]="true"
        [inputBasicOptions]="{
          indexAxis: 'y',
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              ticks: {
                callback: undefined,
              },
            },
          },
        }"
      />
      <div class="vc-surface p-6">
        <div class="mb-6">
          <h2 class="text-xl font-bold text-slate-900 flex items-center gap-2">
            <i class="bi bi-grid text-purple-600"></i>
            Desglose por Producto
          </h2>
          <p class="mt-1 text-sm text-slate-500">Ventas de cada producto dentro de su categoría</p>
        </div>
        <div class="space-y-3 max-h-96 overflow-y-auto pr-2">
          @for (cat of resumen_ingresos_por_categoria(); track cat.categoria_id) {
            <div class="border border-slate-200 rounded-lg p-3">
              <div class="flex justify-between items-center mb-2">
                <span class="font-semibold text-slate-800 text-sm">{{ cat.categoria_nombre }}</span>
                <span class="font-bold text-sm text-purple-600">{{
                  cat.monto_total | currency: 'PEN' : 'S/. '
                }}</span>
              </div>
              <div class="space-y-1">
                @for (prod of cat.productos; track prod.producto_id) {
                  <div
                    class="flex justify-between items-center text-xs text-slate-600 pl-2 border-l-2 border-purple-200"
                  >
                    <span class="truncate mr-2">{{ prod.producto_nombre }}</span>
                    <span class="text-slate-500 whitespace-nowrap"
                      >{{ prod.unidades_vendidas }} un. ·
                      {{ prod.monto_total | currency: 'PEN' : 'S/. ' }}</span
                    >
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  @if (!hasRangoSeleccionado()) {
    <div class="vc-surface p-8 md:p-10">
      <div class="flex flex-col items-center text-center gap-4">
        <span
          class="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-100 text-sky-700"
        >
          <i class="bi bi-bar-chart-line text-2xl"></i>
        </span>
        <h3 class="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900">
          Tu panel está listo para analizar ventas
        </h3>
        <p class="max-w-2xl text-sm md:text-base text-slate-600">
          Selecciona un rango de fechas para cargar métricas comerciales, productos más vendidos y
          comportamiento de clientes.
        </p>

        <div class="mt-2 flex flex-wrap justify-center gap-2">
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.HOY)"
          >
            Hoy
          </button>
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.ULTIMOS_7_DIAS)"
          >
            Últimos 7 días
          </button>
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.ESTE_MES)"
          >
            Este mes
          </button>
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.MES_PASADO)"
          >
            Mes pasado
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="vc-surface p-8 md:p-10">
      <div class="flex flex-col items-center text-center gap-4">
        <span
          class="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-amber-700"
        >
          <i class="bi bi-exclamation-triangle text-2xl"></i>
        </span>
        <h3 class="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900">
          No se encontraron resultados para ese rango
        </h3>
        <p class="max-w-2xl text-sm md:text-base text-slate-600">
          Prueba un periodo más amplio o usa un atajo rápido para encontrar movimientos con mayor
          actividad.
        </p>
        <div class="mt-2 flex flex-wrap justify-center gap-2">
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.ULTIMOS_7_DIAS)"
          >
            Últimos 7 días
          </button>
          <button
            type="button"
            class="vc-btn-secondary px-3 py-2 text-sm"
            (click)="aplicarAtajoRapido(EAtajoRangoTiempo.ESTE_MES)"
          >
            Este mes
          </button>
        </div>
      </div>
    </div>
  }
}
